import { render } from "./EmbedView.vue?vue&type=template&id=03388ddc"
import script from "./EmbedView.vue?vue&type=script&lang=js"
export * from "./EmbedView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__